import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SizingTools.module.scss';
import { Accordion, AccordionDetails, AccordionSummary, Switch, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LightTooltip } from './PdnManifoldSizingTool';
import ApiService from '../../services/ApiService';
import SystemService from '../../services/SystemService';

export default function SizingToolHeader(props: {
  toolName: string | undefined | null;
  isMetric: boolean;
  setIsMetric: React.Dispatch<React.SetStateAction<boolean>>;
  guideMap: Map<string, string>;
  canValidateAPart?: boolean;
  overview: JSX.Element;
}) {
  const { t } = useTranslation();
  const { toolName, isMetric, setIsMetric, guideMap, canValidateAPart, overview } = props;
  const isSizingLaunchedFromDashboard = !!SystemService.getCurrentState()?.system;
  const guideFile = guideMap.get(ApiService.getState().language as string);
  const overviewExpandedKey = 'Sizing-Tool-Overview-Expanded';
  const expand = (localStorage.getItem(overviewExpandedKey) ?? 'true') === 'true';
  const handleOverviewAccordionChange = (event: SyntheticEvent<Element, Event>, expanded: boolean) => {
    localStorage.setItem(overviewExpandedKey, expanded.toString());
  };

  return (
    <>
      <div className={styles['sizing-tool-header']}>
        <div className={styles['virtual-engineer-title-div']}>
          <img src={`${process.env.REACT_APP_LEGACY_BASE_HOST}/Content/img/Virtual-Engineer-word.svg`} alt="Virtual Engineer logo" />
        </div>
        <div className={styles['tool-name']}>{toolName}</div>

        <div className={styles['buttons-switch-wrapper']}>
          <div className={styles['icons-container']}>
            {guideFile && (
              <LightTooltip title={`${t('ViewDetailsSizingGuide')}`} arrow placement="top">
                <a href={`${process.env.REACT_APP_LEGACY_BASE_HOST}/Content/help/${guideFile}`} target="_blank" rel="noreferrer">
                  <FontAwesomeIcon className={styles['book-icon']} icon="book" />
                </a>
              </LightTooltip>
            )}
            {!isSizingLaunchedFromDashboard && (
              <LightTooltip title={`${t('GoToProjects')}`} arrow placement="top">
                <div
                  className={styles['go-to-projects-button']}
                  onClick={() => {
                    window.location.href = `${process.env.REACT_APP_LEGACY_DASHBOARD_SUMMARY_URL}`;
                  }}
                >
                  <FontAwesomeIcon className={styles['briefcase-icon']} icon="briefcase" />
                </div>
              </LightTooltip>
            )}
            {/*help icon*/}
          </div>
          {canValidateAPart && (
            <div className={styles['find-validate-switch-container']}>
              <span>{t('FindPart')}</span>
              <Switch className="toggle-switch-sizing" />
              <span>{t('ValidatePart')}</span>
            </div>
          )}
          <div className={styles['metric-imperial-switch-container']}>
            <span>{t('Metric')}</span>
            <Switch
              className="toggle-switch-sizing"
              id="metricSwitchSizingTool"
              checked={!isMetric}
              onChange={() => {
                setIsMetric(!isMetric);
              }}
            />
            <span>{t('Imperial')}</span>
          </div>
        </div>
      </div>
      <Accordion defaultExpanded={expand} onChange={handleOverviewAccordionChange}>
        <AccordionSummary
          expandIcon={<FontAwesomeIcon className={styles['chevron-icon']} icon="chevron-down" />}
          id="sizing-tool-overview"
          className={styles['accordion-header']}
        >
          <Typography>{t('Overview')}</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ textAlign: 'left' }}>{overview}</AccordionDetails>
      </Accordion>
    </>
  );
}
